import React, { useContext } from 'react';
import Modal from '@components/modal';
import ChatSupportBubble from '@invideoio/web-shared/components/ChatSupportBubble';
import {
  AmplitudeEvents,
  sendAmplitudeAnalyticEvent,
  sendRudderStackAnalyticEvent,
} from '@utils/analytics';
import { PlatformType } from '@invideoio/web-shared/constants/common';
import SubFooter from '@components/sub-footer';
import Footer from '@invideoio/web-shared/components/Footer';
import { StateContext } from '../store/store';
import ivclass from '@invideoio/web-shared/Modules/IVClass';
import { ClickCtaType, ClickCtaUxSource } from 'src/types/analytics';

interface AppLayoutProps {
  children: React.ReactNode;
  platform: PlatformType;
}

const AppLayout = ({ children, platform }: AppLayoutProps) => {

  const globalState = useContext(StateContext);
  const { os, socialLinks } = globalState;
  return (
    <React.Fragment>
      {children}
      <SubFooter platform={platform} />
      <Footer os={os} platform={platform} socialLinks={socialLinks} />
      <Modal platform={platform} />
    </React.Fragment>
  );
};

export default AppLayout;
